import React, { useEffect, useState } from "react";
import "assets/scss/partials/teamdashboard.scss";
import circleAnimation from "assets/img/icons/circle-animation.gif";

import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import Loader from "components/Loader";
import { ReactComponent as RightArrow } from "assets/img/icons/rightArrow.svg";
import * as moment from "moment";
import { useHistory } from "react-router-dom";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";
import { useUserContext } from "store/contexts/userContext";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";

export default ({ onClose = null }) => {
  const { team } = useTeamContext();
  const dispatch = useDispatch();
  const history = useHistory();
  const [userDashboard, setUserDashboard] = useState([]);
  const [rank, setRank] = useState(null); 

  const { allTimelinePost, setFilters, closeDrawer, mobileRightSidebarOpen } =
    useTeamActionContext();
  const [happinessMeter, setHappinessMeter] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const { user } = useUserContext();
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    (async () => {
      try {
        var allResponses = await Promise.all([
          TeamService.getUserDashboard(team?.id),
          TeamService.getNetThrivingScoreStatsDetails(team?.id),
        ]);

        setHappinessMeter(
          allResponses[1].data.data.filter(
            (member) => member.id === allResponses[0].data.data.user_id
          )
        );
        setUserDashboard(allResponses[0].data.data);
        setRank(allResponses[0].data.data.rank);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    })();
  }, [team.id]);

  const goToTimeline = async (value) => {
    if (onClose) {
      onClose();
    }

    if (mobileRightSidebarOpen) {
      closeDrawer();
    }

    var filterData = {
      type_id: [],
      selectMembers: [],
      taggedMembers: [],
      date_from: null,
      date_to: null,
    };

    var userData = {
      id: userDashboard.user_id,
      first_name: user?.first_name,
      last_name: user?.last_name,
      full_name: user?.full_name,
      avatar: user?.avatar,
    };

    if (value === "post") {
      filterData = {
        ...filterData,
        selectMembers: [userData],
      };
    }

    if (value === "recognition") {
      filterData = {
        ...filterData,
        type_id: [8],
        taggedMembers: [userData],
      };
    }

    try {
      if (!onClose) {
        history.push(`/teams/${team.id}/timeline`);
      }
      await Promise.all([
        dispatch(timelineActions.clearAll()),
        setFilters(filterData),
        allTimelinePost(1, null, filterData),
      ]);
    } catch (e) {
      console.log(e);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const gap = {
    display: "flex",
    gap: "20px",
  };

  function calculateProgressWidth() {
    const points = rank?.points || 0;
    if (points <= 50) {
      return (points / 50) * 100;
    } else if (points <= 200) {
      return ((points - 50) / 150) * 100;
    } else if (points <= 500) {
      return ((points - 200) / 300) * 100;
    } else if (points <= 1000) {
      return ((points - 500) / 500) * 100;
    } else {
      return 100;
    }
  }

  const closeIcon = (
    <Button type="button" buttonClass="btn-close modalClose2">
      <CloseIcon onClick={toggleModal} />
    </Button>
  );

  return (
    <>
      {isLoading && (
        <div style={loaderStyle}>
          <Loader />
        </div>
      )}
      {!isLoading && (
        <div className="teamdashboard">
          <div>
            <div className="topCard">
              <div className="leftContent">
                <div className="lastPostCreated">
                  <span className="leftHeading">My Engagement Points</span>
                </div>

                <Modal
                  open={showModal}
                  onClose={toggleModal}
                  center
                  closeIcon={closeIcon}
                  styles={{
                    modal: {
                      width: "320px",
                    },
                  }}
                >
                  <h5>
                    <strong>Earn QR-points by:</strong>
                  </h5>
                  <ul>
                  <li>Respond to a Post</li>
                    <li>Initiate a Check In</li>
                    <li>Respond to a Check In</li>
                    <li>Create a Trivia</li>
                    <li>Complete a Trivia Answer</li>
                    <li>Use the ReTeam AI Assistant</li>
                    <li>Create a Thank You</li>
                    <li>Be Recognized in a Thank you</li>
                    <li>Initiate a Slideshow</li>
                    <li>Respond to a Slideshow</li>
                    <li>Initiate a Team Video</li>
                    <li>Respond in Video to a Team Video</li>
                    <li>Create a New Idea</li>
                    <li>Post Idea to Innovation Vista</li>
                    <li>Create a Survey</li>
                    <li>Respond to a Survey</li>
                    <li>Create a Poll</li>
                    <li>Respond to a Poll</li>
                    <li>Respond to a Riddle of the Day</li>
                  </ul>
                </Modal>

                <div>
                  <div class="progress-bar-container">
                    <div class="progress-bar">
                      <div class="progress-bar-inner">
                        <div
                          class="progress-bar-fill"
                          style={{ width: `${calculateProgressWidth()}%` }}
                        >
                          <span className="progress-bar-text">
                            {rank?.points} Pts
                          </span>
                        </div>
                      </div>
                    </div>

                    <span class="progress-label left-label">
                      {rank?.min_points} Pts
                    </span>
                    <span class="progress-label right-label">
                      {rank?.max_points} Pts
                    </span>
                  </div>
                  <div className="earnPoints">
                    <button
                      className="btn btn-primary btn-sm mt-3 yellow-button"
                      onClick={toggleModal}
                    >
                      Earn Points
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div className="happinessContent">
                  <div className="circleRoot">
                    <img
                      className="circleAnimation"
                      src={rank?.icon}
                      alt="loading..."
                    />
                  </div>
                  {/* <span className="happinessName">{rank?.name}</span> */}
                </div>
              </div>
            </div>

            <div className="topCard">
              <div className="leftContent">
                <div className="lastPostCreated">
                  <span className="leftHeading">Last Post Created</span>
                  <span>
                    <span>
                      {userDashboard?.team_last_created_post_date &&
                        moment(
                          userDashboard?.team_last_created_post_date
                        ).format("Do MMM, YYYY")}
                      {!userDashboard?.team_last_created_post_date && "N/A"}
                    </span>
                  </span>
                </div>
                <div className="lastTeamRecognition">
                  <span className="leftHeading">My Last Recognition</span>
                  <span>
                    {userDashboard?.team_last_recognition_date &&
                      moment(userDashboard?.team_last_recognition_date).format(
                        "Do MMM, YYYY"
                      )}
                    {!userDashboard?.team_last_recognition_date && "N/A"}
                  </span>
                </div>
                {/* <div className="lastTeamRecognition">
                  <span className="leftHeading">My Achieve Points</span>
                  <span>60</span>
                </div> */}
              </div>
              <div style={gap}>
                <div className="happinessMeter">
                  <div className="circleRoot">
                    <img
                      className="circleAnimation"
                      src={circleAnimation}
                      alt="loading..."
                    />
                    <span className="circleContent">
                      {happinessMeter[0].happiness_meter}%
                    </span>
                  </div>
                  <span className="happinessContent">Happiness Meter</span>
                </div>
                {/* <div className="happinessContent">
                  <div className="circleRoot">
                    <img
                      className="circleAnimation"
                      src={Badge}
                      alt="loading..."
                    />
                  </div>
                  <span className="myBadge">My Badge</span>
                </div> */}
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 ">
              <div
                className="dashboardContent postColor"
                onClick={() => goToTimeline("post")}
              >
                <span className="data">{userDashboard?.team_post_count}</span>
                <div className="stateName">
                  <span>My Posts</span>
                </div>
                <div className="statFooter">
                  <span>View More</span>
                  <span>
                    <RightArrow />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 ">
              <div
                onClick={() => goToTimeline("recognition")}
                className="dashboardContent recognitionColor"
              >
                <span className="data">
                  {userDashboard?.team_recognition_count}
                </span>
                <div className="stateName">
                  <span>My Recognitions</span>
                </div>
                <div className="statFooter">
                  <span>View More</span>
                  <span>
                    <RightArrow />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
              <div className="tasksContent">
                <div className="taskData">
                  <span>My Tasks</span>
                  <span>{userDashboard?.team_assigned_task_count}</span>
                </div>
                <div className="taskData pendingTask">
                  <span>Pending Tasks</span>
                  <span>{userDashboard?.team_assigned_pending_count}</span>
                </div>
                <div className="taskData completeTask">
                  <span>Completed Tasks</span>
                  <span>
                    {userDashboard?.team_assigned_completed_task_count}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
